import { render, staticRenderFns } from "./-Projects.vue?vue&type=template&id=2e16e54d&scoped=true&"
import script from "./-Projects.vue?vue&type=script&lang=js&"
export * from "./-Projects.vue?vue&type=script&lang=js&"
import style0 from "./-Projects.vue?vue&type=style&index=0&id=2e16e54d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16e54d",
  null
  
)

export default component.exports